import mixins from 'vue-typed-mixins';

import { Eフェーズ種別, E補助科目フラグ } from '@/openapi/enum';

import PlbscfTable from '@/components/plbscfTable/PlbscfTable.vue';
import C計画書データ表示設定CheckBox from '@/components/計画書データ表示設定CheckBox/計画書データ表示設定CheckBox.vue';

import PlbscfMixin from '@/entries/user/mixins/PlbscfMixin';
import PlbscfKeystrokeResetMixin from '@/entries/user/mixins/PlbscfKeystrokeResetMixin';
import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';
import 勘定科目UpdateOrderCheckerMixin from '@/entries/user/mixins/勘定科目UpdateOrderCheckerMixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';

import { PlbscfTypeList } from '@/classes/service/AbstractPlbscfService';
import 分析PlbscfService from '@/classes/service/分析/分析PlbscfService';
import { PlbscfType } from '@/master/Plbscf';

export default mixins(
  PlbscfMixin,
  事業所Mixin,
  勘定科目UpdateOrderCheckerMixin,
  計画書Mixin,
  PlbscfKeystrokeResetMixin
).extend({
  name: 'M分析PlbscfMixin',

  components: {
    PlbscfTable,
    C計画書データ表示設定CheckBox,
  },

  data(): {
    service: 分析PlbscfService;
    plbscfTypeLists: PlbscfTypeList[];
  } {
    return {
      service: new 分析PlbscfService(Eフェーズ種別.分析フェーズ),
      plbscfTypeLists: [],
    };
  },

  computed: {
    plbscfTypeListsOfTabTypes(): PlbscfTypeList[] {
      const tabTypes: PlbscfType[] = [this.tabType];
      if (this.isCF計算書Tab) tabTypes.push(PlbscfType.CF計算書_計算式);
      return this.plbscfTypeLists.filter((plbscfTypeList) => tabTypes.includes(plbscfTypeList.type));
    },
  },

  watch: {
    plbscfTypeLists: {
      handler(newVal: PlbscfTypeList[], oldVal: PlbscfTypeList[]): void {
        // load時は再計算せず終了
        if (this.isLoading) {
          this.isLoading = false;
          return;
        }
        if (oldVal.length === 0) return;
        // 初回変更時、編集中フラグを立てる
        this.isEditing = true;
      },
      deep: true,
    },
    tabType(): void {
      this.addKeystrokeResetCount();
    },
  },

  async created(): Promise<void> {
    await this.loadAndResetKeystroke();
  },

  methods: {
    async load(): Promise<void> {
      // 勘定科目一覧　取得用
      const 勘定科目Options = { params: { sj: 'PLBSCF_分析' } };
      const 勘定科目Request = this.api.k.list勘定科目(
        this.事業所.pk,
        E補助科目フラグ.通常,
        undefined,
        undefined,
        勘定科目Options
      );
      // データ一覧　取得用
      const データOptions = { params: { sj: 'PLBSCF' } };
      const データRequest = this.api.d.listデータ(
        this.計画書.pk,
        this.service.getRelationalE入力分類s(),
        Eフェーズ種別.分析フェーズ,
        データOptions
      );
      // API呼び出し
      const responses = await Promise.all([勘定科目Request, データRequest]);
      this.service.set勘定科目s = responses[0].data;
      this.plbscfTypeLists = this.service.parse(responses[1].data);
      this.initializeFlag();
      this.setPksCannotUpdateOrder(responses[0].data);
    },
    onChange0円非表示フラグ(): void {
      this.plbscfTypeLists = this.service.createPlbscfTypeList();
      this.initializeFlag();
      this.addKeystrokeResetCount();
    },
    async loadAndResetKeystroke(): Promise<void> {
      await this.load();
      this.addKeystrokeResetCount();
    },
  },
});
